import { render, staticRenderFns } from "./QuestionList.vue?vue&type=template&id=c8e21d10&scoped=true&"
import script from "./QuestionList.vue?vue&type=script&lang=ts&"
export * from "./QuestionList.vue?vue&type=script&lang=ts&"
import style0 from "./QuestionList.vue?vue&type=style&index=0&id=c8e21d10&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c8e21d10",
  null
  
)

export default component.exports